module.exports = __webpack_public_path__ + "static/images/m-lef-sort@2x.695242b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit/config/m-lef-sort@2x.png
// module id = nmWJ
// module chunks = 6 7